/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';

const useValidator = (customMessage = {}, customValidator = {}) => {
  const [show, setShow] = useState(false);
  const validator = new SimpleReactValidator({
    // messages: customMessage,
    messages: {
      userEmailID: 'El campo nombre es requerido',
      email: 'Email not valid',
      required: 'Required',
    },
    element: (message) => t(message),
    validators: customValidator,
  });

  const t = (message) => {
    message = message.replace('i d', 'id');
    return <p className="error-shipping">{message}</p>;
  };

  if (show) {
    validator.showMessages();
  }
  return [validator, setShow];
};

export default useValidator;
